document.addEventListener("DOMContentLoaded", function () {
  var splide = new Splide(".splide-awards-recognitions", {
    perPage: 3,
    perMove: 1,
    type: "loop",
    flickMaxPages: 1,
    flickPower: 100,
    // waitForTransition: true,

    type: "loop",
    updateOnMove: true,
    speed: 800,
    focus: "center",
    pagination: false,
    perMove: 1,
    snap: true,
    gap: "16px",
    classes: {
      arrows: "splide__arrows splide-awards-recognitions-arrows",
      arrow: "splide__arrow splide-awards-recognitions-arrow",
      prev: "splide__arrow--prev splide-awards-recognitions-prev",
      next: "splide__arrow--next splide-awards-recognitions-next",
    },
    arrowPath:
      "M22 13.7344L20.6 15.1844L24.15 18.7344H12V20.7344H24.15L20.6 24.2844L22 25.7344L28 19.7344L22 13.7344Z",
    breakpoints: {
      1170: {
        perPage: 2.2,
        perMove: 1,
        arrows: false,
      },
      1024: {
        perPage: 2.2,
        perMove: 1,
      },
      640: {
        gap: "5px",
        padding: "0%",
        perPage: 1.5,
      },
    },
  });
  var textSplide = new Splide("#awards-recognition-thumbnails", {
    type: "slide",
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: false,
    updateOnMove: true,
    speed: 0,
    focus: "center",
  });

  splide.sync(textSplide);

  splide.mount();
  textSplide.mount();

  splide.on("move", function (newIndex) {
    // Remove the 'is-active' class from all slides
    splide.Components.Elements.slides.forEach((slide, index) => {
      if (index === newIndex) {
        slide.classList.add("is-active");
      } else {
        slide.classList.remove("is-active");
      }
    });
  });
});
